export const PLAN_VIEW_MODE = {
  PLAN: 'PLAN',
  STRUCTURED: 'STRUCTURED'
}
